(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7918],{

/***/ 61168:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/glossary",
      function () {
        return __webpack_require__(32218);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36822);






var Image = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var ratio = _param.ratio, _disabledEffect = _param.disabledEffect, disabledEffect = _disabledEffect === void 0 ? false : _disabledEffect, _effect = _param.effect, effect = _effect === void 0 ? "blur" : _effect, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "ratio",
        "disabledEffect",
        "effect",
        "sx"
    ]);
    var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        component: react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__.LazyLoadImage,
        wrapperClassName: "wrapper",
        effect: disabledEffect ? undefined : effect,
        placeholderSrc: disabledEffect ? "/assets/transparent.png" : "/assets/placeholder.svg",
        sx: {
            width: 1,
            height: 1,
            objectFit: "cover"
        }
    }, other));
    if (ratio) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            ref: ref,
            component: "span",
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                width: 1,
                lineHeight: 1,
                display: "block",
                overflow: "hidden",
                position: "relative",
                pt: getRatio(ratio),
                "& .wrapper": {
                    top: 0,
                    left: 0,
                    width: 1,
                    height: 1,
                    position: "absolute",
                    backgroundSize: "cover !important"
                }
            }, sx),
            children: content
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        ref: ref,
        component: "span",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            position: "relative",
            "& .wrapper": {
                width: 1,
                height: 1,
                backgroundSize: "cover !important"
            }
        }, sx),
        children: content
    });
});
function getRatio() {
    var ratio = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1/1";
    return ({
        "4/3": "calc(100% / 4 * 3)",
        "3/4": "calc(100% / 3 * 4)",
        "6/4": "calc(100% / 6 * 4)",
        "4/6": "calc(100% / 4 * 6)",
        "16/9": "calc(100% / 16 * 9)",
        "9/16": "calc(100% / 9 * 16)",
        "21/9": "calc(100% / 21 * 9)",
        "9/21": "calc(100% / 9 * 21)",
        "1/1": "100%"
    })[ratio];
}
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 32218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Tags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(50122);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40549);
/* harmony import */ var _hooks_useSettings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10901);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67918);
/* harmony import */ var _hooks_useApp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28821);
/* harmony import */ var _layouts_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72575);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61582);
/* harmony import */ var _sections_e_commerce_shop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21340);
/* harmony import */ var _routes_paths__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96259);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89734);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89419);
/* harmony import */ var change_case__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(48389);







// @mui


// hooks



// layouts

// components

// sections






// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        paddingTop: theme.spacing(8)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(11)
    });
});
// ----------------------------------------------------------------------
Tags.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_index__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function Tags(param) {
    var _allTags = param.allTags, allTags = _allTags === void 0 ? [] : _allTags, globalSetting = param.globalSetting;
    var themeStretch = (0,_hooks_useSettings__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().themeStretch;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), locale = ref.locale, query = ref.query;
    var ref1 = (0,_hooks_useApp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), logo = ref1.logo, host = ref1.host, rootTitle = ref1.title;
    var isLocaleEnglish = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return locale === "en";
    }, [
        locale
    ]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        search: null
    }), filter = ref2[0], setFilter = ref2[1];
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().translate;
    var _search;
    var querySearch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            search: Array.isArray(query.search) ? "" : (_search = query.search) !== null && _search !== void 0 ? _search : ""
        };
    }, [
        query
    ]);
    var _search1;
    var combinedFilter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            search: (_search1 = filter.search) !== null && _search1 !== void 0 ? _search1 : querySearch.search
        };
    }, [
        filter,
        querySearch
    ]);
    var filteredTags = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return lodash_sortBy__WEBPACK_IMPORTED_MODULE_10___default()(allTags, function(tag) {
            return tag.name.toLocaleLowerCase();
        }).filter(function(tag) {
            if (combinedFilter.search) {
                return tag.name.toLowerCase().includes(combinedFilter.search.toLowerCase());
            }
            return true;
        });
    }, [
        allTags,
        combinedFilter
    ]);
    var allEnglishLetter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var letters = [];
        for(var i = 65; i <= 90; i++){
            letters.push(String.fromCharCode(i));
        }
        return letters;
    }, []);
    var OTHERS_LETTER = "Others";
    var groupByEnglishLetterFilteredTags = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var tagGroups = {};
        var cloneFilteredTags = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_11___default()(filteredTags);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var letter = _step.value;
                if (!tagGroups[letter]) {
                    tagGroups[letter] = [];
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var filteredTag = _step1.value;
                        if (filteredTag.name.charAt(0).toUpperCase() === letter) {
                            tagGroups[letter].push(filteredTag);
                            cloneFilteredTags = cloneFilteredTags.filter(function(tag) {
                                return tag.id !== filteredTag.id;
                            });
                        }
                    };
                    for(var _iterator = filteredTags[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
            for(var _iterator = allEnglishLetter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        tagGroups[OTHERS_LETTER] = cloneFilteredTags;
        return tagGroups;
    }, [
        allEnglishLetter,
        filteredTags
    ]);
    var handleScrollToLetter = function(letterId) {
        var letterElement = document.getElementById(letterId);
        if (letterElement) {
            var extraHeight = 100;
            var top = letterElement.getBoundingClientRect().top;
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            window.scrollTo({
                top: scrollTop + top - extraHeight,
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        title: translate("common.glossary"),
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: translate("common.glossary"),
            url: "https://".concat(host, "/").concat(locale, "/glossary"),
            "@id": "https://".concat(host, "/").concat(locale, "/glossary"),
            publisher: {
                "@type": "Organization",
                name: rootTitle !== null && rootTitle !== void 0 ? rootTitle : "",
                logo: {
                    "@type": "ImageObject",
                    url: logo !== null && logo !== void 0 ? logo : ""
                }
            },
            mainEntity: {
                "@type": "ItemList",
                name: translate("common.glossary"),
                itemListElement: filteredTags.map(function(tag, index) {
                    var ref;
                    return {
                        "@type": "ListItem",
                        position: index + 1,
                        name: tag.name,
                        description: (tag === null || tag === void 0 ? void 0 : (ref = tag.content) === null || ref === void 0 ? void 0 : ref.json) ? (0,_contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_12__/* .documentToPlainTextString */ .a)(tag.content.json).slice(250) : ""
                    };
                })
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyle, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                maxWidth: themeStretch ? false : "lg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        textAlign: "center",
                        variant: "h4",
                        my: 5,
                        children: translate("common.glossary")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        spacing: 2,
                        direction: "column",
                        alignItems: {
                            sm: "center"
                        },
                        justifyContent: "center",
                        sx: {
                            mb: 10,
                            mt: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_e_commerce_shop__WEBPACK_IMPORTED_MODULE_8__/* .ShopProductSearch */ .W, {
                                value: combinedFilter.search,
                                onSearch: function(value) {
                                    return setFilter(function(prev) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, prev), {
                                            search: value
                                        });
                                    });
                                }
                            }),
                            isLocaleEnglish && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                spacing: 2,
                                direction: "row",
                                alignItems: {
                                    sm: "center"
                                },
                                justifyContent: "center",
                                flexWrap: "wrap",
                                sx: {
                                    mt: 5
                                },
                                children: [
                                    allEnglishLetter.map(function(letter) {
                                        var isDisabled = groupByEnglishLetterFilteredTags[letter].length < 1;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            variant: "h6",
                                            sx: {
                                                color: isDisabled ? "text.disabled" : "text.primary",
                                                cursor: isDisabled ? "not-allowed" : "pointer"
                                            },
                                            onClick: function() {
                                                return !isDisabled && handleScrollToLetter(letter);
                                            },
                                            children: letter
                                        }, letter);
                                    }),
                                    groupByEnglishLetterFilteredTags[OTHERS_LETTER].length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        variant: "h6",
                                        sx: {
                                            color: "text.primary",
                                            cursor: "pointer"
                                        },
                                        onClick: function() {
                                            return handleScrollToLetter(OTHERS_LETTER);
                                        },
                                        children: OTHERS_LETTER
                                    })
                                ]
                            })
                        ]
                    }),
                    isLocaleEnglish ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        sx: {
                            display: "grid",
                            gap: 10,
                            gridTemplateColumns: {
                                xs: "repeat(1, 1fr)",
                                sm: "repeat(2, 1fr)",
                                md: "repeat(3, 1fr)",
                                lg: "repeat(4, 1fr)"
                            }
                        },
                        children: Object.entries(groupByEnglishLetterFilteredTags).map(function(param) {
                            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(param, 2), letter = _param[0], tags = _param[1];
                            return tags.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        id: letter,
                                        variant: "h6",
                                        sx: {
                                            color: "text.primary"
                                        },
                                        children: letter
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        sx: {
                                            my: 1
                                        }
                                    }),
                                    tags.map(function(tag) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            href: "".concat(_routes_paths__WEBPACK_IMPORTED_MODULE_9__/* .PATH_PAGE.glossary */ .ko.glossary, "/").concat(tag.slug),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                sx: {
                                                    color: "text.secondary",
                                                    my: 1,
                                                    cursor: "pointer"
                                                },
                                                children: (0,change_case__WEBPACK_IMPORTED_MODULE_24__/* .capitalCase */ .I)(tag.name)
                                            })
                                        }, tag.name);
                                    })
                                ]
                            }, letter + tags.length) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        sx: {
                            display: "grid",
                            gap: 3,
                            gridTemplateColumns: {
                                xs: "repeat(1, 1fr)",
                                sm: "repeat(2, 1fr)",
                                md: "repeat(3, 1fr)",
                                lg: "repeat(4, 1fr)"
                            }
                        },
                        children: filteredTags.map(function(filteredTag) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                href: "".concat(_routes_paths__WEBPACK_IMPORTED_MODULE_9__/* .PATH_PAGE.glossary */ .ko.glossary, "/").concat(filteredTag.slug),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    sx: {
                                        color: "text.secondary",
                                        my: 1,
                                        cursor: "pointer"
                                    },
                                    children: filteredTag.name
                                })
                            }, filteredTag.name);
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 13162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ fNumber; },
/* harmony export */   "e_": function() { return /* binding */ fCurrency; }
/* harmony export */ });
/* unused harmony exports fPercent, fShortenNumber, fData */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);

// ----------------------------------------------------------------------
function fCurrency(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(Number.isInteger(number) ? "$0,0" : "$0,0.00");
}
function fPercent(number) {
    return numeral(number / 100).format("0.0%");
}
function fNumber(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format();
}
function fShortenNumber(number) {
    return numeral(number).format("0.00a").replace(".00", "");
}
function fData(number) {
    return numeral(number).format("0.0 b");
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6547,513,9694,1664,9463,7952,4894,1997,2679,2077,5644,6621,8424,6755,3907,2575,1340,9774,2888,179], function() { return __webpack_exec__(61168); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);